import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  open = false;

  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['btn', 'close', 'submenu', 'menuLinks[]', 'cols[]'],
  };

  /**
   *
   */
  mounted() {
    window.dataLayer = window.dataLayer || [];
  }

  /**
   * Click on Item with submenu
   * @param {object} props Props
   * @param {object} props.event current event
   * @param {object} props.target current element
   * @returns {void}
   */
  onBtnClick({ event, target }) {
    if (
      !this.open &&
      this.$refs.submenu &&
      document.documentElement.classList.contains('is-menu-open')
    ) {
      event.preventDefault();
      this.openSubmenu();
    }

    window.dataLayer.push({
      event: 'menu_click',
      entry_category: this.$el.dataset.category,
      entry_destination_url: target.href,
      entry_position: `${this.menuItemIndex}-0-0`,
    });
  }

  /**
   * Close menu item
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onCloseClick({ event }) {
    event.stopPropagation();
    this.closeSubmenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openSubmenu() {
    if (this.open) return;

    this.$parent.submenuOpen = true;
    this.$refs.submenu.classList.remove('max-l:translate-x-full');
    this.open = true;
  }

  /**
   * Close menu nothing more
   * @returns {void}
   */
  closeSubmenu() {
    this.$refs.submenu.classList.add('max-l:translate-x-full');
    this.open = false;
    this.$parent.submenuOpen = false;
  }

  /**
   * Get position string in format "menuItem-col-link"
   * @param {HTMLElement} target Clicked link element
   * @returns {string}
   */
  getEntryPosition(target) {
    const col = this.$refs.cols.find((c) => c.contains(target));
    const colIndex = col ? this.$refs.cols.indexOf(col) + 1 : 1;

    const colLinks = Array.from(col ? col.querySelectorAll('[data-ref="menuLinks[]"]') : []);
    const linkIndex = colLinks.indexOf(target) + 1;

    return `${this.menuItemIndex}-${colIndex}-${linkIndex}`;
  }

  /**
   * Track menu link clicks
   * @param {object} props Props
   * @param {object} props.target current element
   */
  onMenuLinksClick({ target }) {
    window.dataLayer.push({
      event: 'menu_click',
      entry_category: this.$el.dataset.category,
      entry_name: target.title.trim(),
      entry_destination_url: target.href,
      entry_position: this.getEntryPosition(target),
    });
  }

  /**
   * Get menu item index (1-based)
   * @returns {number}
   */
  get menuItemIndex() {
    return Array.from(this.$el.parentElement.children).indexOf(this.$el) + 1;
  }
}
